var config = {
  signin: {
    fields: {
      email: {
        name: "email",
        label: "signin_email",
        options: {
          rules: [{
            type: 'email',
            message: 'signin_warn_email_invalid'
          }, {
            required: true,
            message: 'signin_warn_email_empty'
          }]
        }
      },
      password: {
        name: "password",
        label: "signin_password",
        options: {
          rules: [{
            required: true,
            message: 'signin_warn_password_empty'
          }]
        }
      },
      submit: {
        label: 'signin_submit'
      }
    }
  }
};

export default config;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dimio/dist/config.js
// module id = 1337
// module chunks = 0